import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
import axios from 'axios'


export const useFundraiserSubscriberStore = defineStore('fundraiserSubscriber', {
  id: 'fundraiserSubscriber',
  state: () => ({
    items: [],
    api: '/api/v1/fundraiser-subscribers'
  }),
  getters: {
    ...getters
  },
  actions: {
    ...actions
  }
})
